"use client";

import { useEffect } from "react";

export function CapacitorDetector() {
  useEffect(() => {
    const isNative =
      typeof window !== "undefined" &&
      !!(window as any).Capacitor?.isNativePlatform?.();

    if (isNative) {
      document.body.classList.add("capacitor");
    }

    return () => {
      document.body.classList.remove("capacitor");
    };
  }, []);

  return null;
}
